import React, { useState, forwardRef } from "react";
import { DataGrid } from '@mui/x-data-grid';

import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import Button from "components/CustomButtons/Button.js";
import GridItem from "components/Grid/GridItem.js";
import Loader from "components/Loader/Loader";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

import moment from "moment";
import "moment/locale/es";

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

moment.locale("es");

export default function ReporteEjecutivos() {
  
  const useStyles = makeStyles(theme => ({
    ...dashboardStyle,
    cardTitle: {
      marginTop: "0",
      minHeight: "auto",
      fontWeight: "300",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      marginBottom: "3px",
      textDecoration: "none"
    },
    select: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      color: "#D2D2D2",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "1.42857",
      letterSpacing: "unset",
      "&:before": {
        borderColor: "#D2D2D2",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "1.42857",
        letterSpacing: "unset"
      },
      "&:after": {
        borderColor: "#D2D2D2",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "1.42857",
        letterSpacing: "unset"
      }
    },
    container: {
      textAlign: "center"
    },
    content: {
      display: "inline-flex",
      padding: "10px",
      alignItems: "center"
    },
    paddingBottomCard: {
      paddingBottom: "40px"
    },
    marginRight: {
      marginRight: "10px"
    },
    marginBottom: {
      marginBottom: "50px"
    },
    formControl: {
      marginTop: theme.spacing(3.5),
      minWidth: "100%"
    },
    formControl2: {
      minWidth: "100%",
      marginTop: theme.spacing(5)
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    }
  }));

  const classes = useStyles();

  const [selectFechaInicio, setSelectedFechaInicio] = useState(new Date());
  const [selectFechaFin, setSelectedFechaFin] = useState(new Date());

  const [load, setLoad] = useState(false);

  const [color, setColor] = useState("");
  const [message, setMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [columnReporte] = useState([
    { title: "Nombre", field: "Nombre", type: "string", headerClassName: 'super-app-theme--header', width: 600 },
    { title: "Cuenta", field: "Cuenta", type: "string", headerClassName: 'super-app-theme--header', width: 600 }
  ]);

  const [reporte, setReporte] = useState([]);

  const GetIdSucursal = () => {
    return JSON.parse(localStorage.getItem('userRetencion')).IdSucursales;
  };

  const sendSnackBar = (pmessage, pcolor) => {
    setOpenSnackbar(true);
    setColor(pcolor);
    setMessage(pmessage);
  };
  
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const handeSubmit = event => {
    event.preventDefault();
    try{
        setLoad(true);

        let fechaInicio = moment(selectFechaInicio);
        fechaInicio.set({h: 0, m: 0, s: 0});

        let fechaFin = moment(selectFechaFin);
        fechaFin.set({h: 23, m: 59, s: 59});

        Login()
        .then(result => {
            if (result !== undefined) {
                let body = {
                    FechaInicio: fechaInicio.format("YYYY/MM/DD HH:mm:ss"),
                    FechaFin: fechaFin.format("YYYY/MM/DD HH:mm:ss"),
                    IdSucursales: GetIdSucursal()
                };

                ReporteEjecutivos(body, result.token)
                .then(result => {
                      let capturas = result.capturas.map((element) => {
                        element.id = Math.random() * 10;

                        return element;
                      });
                    setReporte(capturas);
                    setLoad(false);
                }).catch(error => console.log(error));
            } else {
                sendSnackBar("Error de conexión", "error");
                setLoad(false);
            }
        }).catch(error => sendSnackBar("Error de conexión", "error"));
    } catch(error){
        sendSnackBar("Error de conexión", "error");
        setLoad(false);
    }
  };

  const ReporteEjecutivos = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Reportes/ReporteEjecutivos",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const Login = async () => {
      let dataResponse;
      try {
          let header = {
              method: "POST",
              body: JSON.stringify({UserName: process.env.REACT_APP_USER, Password: process.env.REACT_APP_PASS}),
              headers: {
                  "Content-Type": "application/json"
              }
          };

          let response = await fetch(
              process.env.REACT_APP_URL_APICORE + "Login",
              header
          );

          dataResponse = await response.json();
      } catch (error) {
          sendSnackBar("Error de conexión", "error");
      }

      return dataResponse;
  };

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Grid className={classes.marginBottom}>
          <Grid container className={classes.paddingBottomCard}>
            <GridItem xs={12} sm={12} md={4}>
              <FormControl className={classes.formControl}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    format="yyyy/MM/dd"
                    label="Fecha inicio"
                    value={selectFechaInicio}
                    onChange={(date) => setSelectedFechaInicio(date)}
                    slotProps={{ textField: { fullWidth: true } }}
                    renderInput={(props) => <TextField {...props} />}
                  />
                </DemoContainer>
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <FormControl className={classes.formControl}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    label="Fecha Final"
                    format="yyyy/MM/dd"
                    value={selectFechaFin}
                    onChange={(date) => setSelectedFechaFin(date)}
                    slotProps={{ textField: { fullWidth: true } }}
                    renderInput={(props) => <TextField {...props} />}
                  />
                </DemoContainer>
              </FormControl>
            </GridItem>
          </Grid>
          <Grid container spacing={3} style={{marginLeft: "1px"}}>
            <GridItem xs={12} sm={12} md={2}>
              <Button
                onClick={e => {
                  handeSubmit(e);
                }}
                color="info"
              >
                Buscar
              </Button>
            </GridItem>
          </Grid>
        </Grid>
      </LocalizationProvider>
      <DataGrid
        rows={reporte}
        columns={columnReporte}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        autoHeight
        sx={{
          boxShadow: 2,
          border: 2,
          borderColor: 'primary.light',
          '& .MuiDataGrid-cell:hover': {
            color: 'primary.main',
          },
          '& .super-app-theme--header': {
            backgroundColor: 'primary.light',
          },
        }}
      />
        <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "right" }} open={openSnackbar} onClose={handleClose} autoHideDuration={6000}>
            <Alert onClose={handleClose} severity={color} sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>
        <Loader load={load} />
    </div>
  );
}